import { useFilters } from '@domain-group/react-hooks'

import { Box, DashboardModule, Link } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useProviderPackage'
import useProviderPackages from '@hooks/useProviderPackages'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import BrandProviderListItem from './ProviderPackageListItem'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
  ]
}

const ProviderPackages = (props: { serviceProductId: number }) => {
  const { serviceProductId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const options = {
    filters: { service_product_id: serviceProductId, ...pageFilters },
    performHttpRequests: !!serviceProductId,
    requestOptions: {
      include_provider_package_service_product_ids: true,
    },
  }

  const providerPackagesPayload = useProviderPackages(options)
  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredProviderPackages,
    filteredProviderPackagesCount,
    hasFilteredProviderPackages,
    loading,
  } = providerPackagesPayload

  const { providerPackagesIndexUrl } = generateUrls()

  return (
    <DashboardModule
      boxProps={{ id: 'realhub-nav-packages' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Packages"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        {!loading && !hasFilteredProviderPackages && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Packages present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              You can assign the product to a package <Link href={providerPackagesIndexUrl}>here</Link>.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredProviderPackages && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredProviderPackages.map(providerPackage => (
              <BrandProviderListItem
                key={providerPackage.id}
                providerPackage={providerPackage}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredProviderPackagesCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}

export default ProviderPackages
